import React, { useState } from 'react';
import axios from 'axios';

const AddProcess = () => {
  // State to manage form inputs
  const [processName, setProcessName] = useState('');
  const [colorCode, setColorCode] = useState('#ffffff');
  const [processes, setProcesses] = useState([]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!processName) {
      alert('Process name is required!');
      return;
    }
    try {
      // Send data to the backend API
      const response = await axios.post('http://35.159.43.224:5000/api/processes', {
        name: processName,
        color: colorCode,
      });

      // Add new process to the local state
      setProcesses([...processes, response.data]);
      setProcessName('');
      setColorCode('#ffffff');
    } catch (error) {
      console.error('Error adding process:', error);
    }
  };

  return (
    <div>
      <h1>Process Manager</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Process Name:
          <input
            type="text"
            value={processName}
            onChange={(e) => setProcessName(e.target.value)}
            required
          />
        </label>
        <br />
        <label>
          Color Code:
          <input
            type="color"
            value={colorCode}
            onChange={(e) => setColorCode(e.target.value)}
          />
        </label>
        <br />
        <button type="submit">Add Process</button>
      </form>

      <h2>Processes</h2>
      <ul>
        {processes.map((process, index) => (
          <li key={index} style={{ backgroundColor: process.color }}>
            {process.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AddProcess;
